"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 2c-4.2 0-8 3.22-8 8.2 0 3.18 2.45 6.92 7.34 11.23.38.33.95.33 1.33 0C17.55 17.12 20 13.38 20 10.2 20 5.22 16.2 2 12 2m.71 13.7c-.19.2-.43.3-.71.3-.27 0-.53-.11-.71-.3-.19-.19-.3-.44-.29-.71-.01-.55.43-.99.98-1H12c.55-.01.99.43 1 .98v.02c0 .28-.1.52-.29.71m1.98-5.79c-.21.35-.48.71-.89 1.09-.32.3-.53.56-.65.77-.1.19-.16.49-.16.69v.07c-.01.27-.24.47-.51.47h-.85c-.28 0-.5-.22-.5-.5v-.16c0-.45.1-.84.29-1.16.19-.33.52-.7 1-1.12.28-.25.48-.47.61-.66s.19-.4.19-.64c0-.29-.11-.54-.32-.74-.22-.2-.5-.3-.85-.3-.37 0-.74.1-.96.3-.12.12-.21.23-.29.38-.03.07-.08.21-.09.26-.05.17-.24.34-.47.34h-.69c-.26 0-.47-.19-.5-.45-.01-.08 0-.16.02-.24.18-.72.52-1.16.9-1.52.56-.5 1.28-.79 2.03-.79.59 0 1.11.12 1.57.35s.79.55 1.05.96c.25.41.38.85.38 1.35 0 .49-.11.9-.31 1.25"
}), 'NotListedLocationRounded');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/NotListedLocationRounded.js
// module id = 4181
// module chunks = 0